import { TranslationEntry } from '@app/shared/models/translatable';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';

export enum TimePeriod {
    TODAY = 'TODAY',
    LAST_5_DAYS = 'LAST_5_DAYS',
    LAST_10_DAYS = 'LAST_10_DAYS',
    LAST_20_DAYS = 'LAST_20_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_60_DAYS = 'LAST_60_DAYS',
    LAST_90_DAYS = 'LAST_90_DAYS',
    SPECIFIC = 'SPECIFIC'
}

export class TimePeriods {
    public static ALL: TranslationEntry[] = [
        { key: TimePeriod.TODAY, trans: marker('time_period.today') },
        { key: TimePeriod.LAST_5_DAYS, trans: marker('time_period.last_5_days') },
        { key: TimePeriod.LAST_10_DAYS, trans: marker('time_period.last_10_days') },
        { key: TimePeriod.LAST_20_DAYS, trans: marker('time_period.last_20_days') },
        { key: TimePeriod.LAST_30_DAYS, trans: marker('time_period.last_30_days') },
        { key: TimePeriod.LAST_60_DAYS, trans: marker('time_period.last_60_days') },
        { key: TimePeriod.LAST_90_DAYS, trans: marker('time_period.last_90_days') },
        { key: TimePeriod.SPECIFIC, trans: marker('time_period.specific') }
    ];

    public static getByKey(key: string): TranslationEntry {
        key = typeof key === 'string' ? key.toUpperCase() : key;
        const found = _.find(TimePeriods.ALL, (type: TranslationEntry) => type.key === key);
        return found || { key: null, trans: '' };
    }

    public static get TODAY() {
        return TimePeriods.getByKey(TimePeriod.TODAY);
    }

    public static get LAST_5_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_5_DAYS);
    }

    public static get LAST_10_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_10_DAYS);
    }

    public static get LAST_20_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_20_DAYS);
    }

    public static get LAST_30_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_30_DAYS);
    }

    public static get LAST_60_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_60_DAYS);
    }

    public static get LAST_90_DAYS() {
        return TimePeriods.getByKey(TimePeriod.LAST_90_DAYS);
    }

    public static get SPECIFIC() {
        return TimePeriods.getByKey(TimePeriod.SPECIFIC);
    }

}
